/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */

import Vue from "vue"
import Router from "vue-router"
import Login from "@/components/Login"
import Registration from "@/components/Registration"
import AccountDetails from "@/components/AccountDetails"
import FlexSearch from "@/components/FlexSearch"
import FlexSearchDetails from "@/components/FlexSearchDetails"
import FlexSearchFileUpload from "@/components/FlexSearchFileUpload"
import Landing from "@/components/Landing"
import store from "@/store"
import { getRoles } from "@/service/menu"

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Landing",
      component: Landing,
      meta: { hideNavBar: true }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { title: "Login" }
    },
    {
      path: "/registration/:plan/:invitationId?",
      component: Registration,
      name: "Registration",
      meta: { title: "Create an Account" },
      props: true
    },
    {
      path: "/account-details",
      component: AccountDetails,
      name: "AccountDetails",
      meta: { title: "Account Details" }
    },
    {
      path: "/flex-search",
      component: FlexSearch,
      name: "FlexSearch",
      meta: { title: "Flexible Search" }
    },
    {
      path: "/flex-search/:batchId/details",
      component: FlexSearchDetails,
      name: FlexSearchDetails.name,
      meta: { title: "Flexible Search Details" },
      props: true
    },
    {
      path: "/flex-search/file-upload",
      component: FlexSearchFileUpload,
      name: FlexSearchFileUpload.name,
      meta: {
        title: "Flexible Search File Upload"
      },
      props: true
    },

    // Lowest Priority route. Keep at bottom of array so this doesn't override any other route
    { path: "**", redirect: { name: "Landing" } }
  ]
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Exclusion Check"

  const roles = to.meta.roles || getRoles(to.path)
  if (store.getters.isLoggedIn) {
    toLoginIfHasNotAccess(next, roles)
  } else {
    store
      .dispatch("getECUserInfo")
      .finally(() => toLoginIfHasNotAccess(next, roles))
  }
})

function toLoginIfHasNotAccess(next, roles) {
  if (store.getters.hasAccess(roles)) {
    next()
  } else {
    next("/login")
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js